import httpRequest from "./index";
import { BaseService } from "./baseService";
import type { MembershipLevelVo } from "../../../../common/types/member";
export class MemberService extends BaseService<any, any, any, any> {
    // 查询会员等级信息
    async getAll(): Promise<MembershipLevelVo[]> {
        const { data } = (await this.service.get(`${this.path}/all`)) as any;
        return data;
    }
}
export const memberService = new MemberService("/membership-level", httpRequest);
